import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {ServicesActions} from '../store';
import {ServicesSelectors} from '../store/selectors';

@Injectable()
export class ServicesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadServicesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadServicesDone() {

    return this.store.pipe(
      select(ServicesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ServicesActions.ReadServices());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
